import './Strikethrough.css';
export var strikethroughCSS = '_4oao6y0-3-5-0';